export const hideAlert = () => {
  const el = document.querySelector('.alert');
  if (el) el.parentElement.removeChild(el);
};

export const showAlert = (type, msg) => {
  hideAlert();
  const markup = `<div class="alert alert--${type}">${msg}</div>`;
  document.querySelector('body').insertAdjacentHTML('afterbegin', markup);
  window.setTimeout(hideAlert, 5000);
};

export const hideImpMenu = () => {
  localStorage.removeItem('impMenuShown');
  location.assign('/');
};

export const showImpMenu = user => {
  hideAlert(); // Hide any existing alerts
  const markup = `
    <div class="alert alert--impersonate">
      <span>Currently impersonating: ${user}</span>
      <button class="btn-stop-impersonate">Stop</button>
    </div>`;
  document.querySelector('body').insertAdjacentHTML('beforeend', markup);
};
